export enum ProjectModule {
  video = <any>'video',
  carousel = <any>'carousel'
}
